import { atom } from "recoil";
import { Entry } from '../../components/EntryListItem/Entry'

const focusedEntryAtom = atom<Entry | null>({
  key: "focusedEntryAtom",
  default: null
});

export default focusedEntryAtom;
